<div class="loaderExcel">
  <mat-card class="progress-card">
    <mat-card-header>
      <mat-card-title>Import de données : </mat-card-title>
      <mat-card-subtitle>{{ title }}</mat-card-subtitle>
      <mat-card-subtitle *ngIf="state === 'closed'">Aucun import en cours !</mat-card-subtitle>
      <mat-card-subtitle *ngIf="state === 'checking'">Recherche d'import !</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content *ngIf="state === 'started'">
      <label>{{ message }} </label>
    </mat-card-content>

    <mat-card-content *ngIf="state === 'processing'">
      <label>{{ message }} : {{ progress / 100 | percent }}</label>

      <mat-progress-bar mode="determinate" [value]="progress" class="progressreportBuild"></mat-progress-bar>
    </mat-card-content>

    <mat-card-content *ngIf="state === 'ended'">
      <label>{{ message }} : {{ 100 / 100 | percent }}</label>

      <mat-progress-bar mode="determinate" [value]="progress" class="progressreportBuild"></mat-progress-bar>

      <label>{{ result | async }}</label>
    </mat-card-content>

    <mat-card-content *ngIf="state === 'error'">
      <label>Le serveur a rencontré une erreur</label>
    </mat-card-content>

    <mat-card-actions align="end">
      <button mat-raised-button (click)="refreshProgress()"><mat-icon color="primary">refresh</mat-icon></button>

      <!--  <button mat-raised-button *ngIf="state === 'ended' || state === 'error'" (click)="clearProgress()" mat-dialog-close>
        <mat-icon color="primary">clear</mat-icon>
      </button> -->
    </mat-card-actions>
  </mat-card>
</div>
